import type { PDFDocumentLoadingTask } from "pdfjs-dist";

const INCORRECT_PASSWORD_RESPONSE = 2;

export type PdfPasswordReason = "need-password" | "incorrect-password";

export type PdfPasswordRequest = {
  reason: PdfPasswordReason;
  attempt: number;
};

export type PdfPasswordProvider = (
  request: PdfPasswordRequest,
) => Promise<string | null> | string | null;

export function toPdfPasswordReason(reason: number): PdfPasswordReason {
  return reason === INCORRECT_PASSWORD_RESPONSE
    ? "incorrect-password"
    : "need-password";
}

export function attachPasswordProvider(
  task: Pick<PDFDocumentLoadingTask, "onPassword">,
  provider: PdfPasswordProvider,
): void {
  let attempt = 0;

  task.onPassword = (
    updatePassword: (password: string | Error) => void,
    reason: number,
  ) => {
    attempt += 1;

    void Promise.resolve(
      provider({
        reason: toPdfPasswordReason(reason),
        attempt,
      }),
    ).then(
      (password) => {
        if (password === null) {
          updatePassword(new Error("PDF password entry was cancelled."));
          return;
        }

        updatePassword(password);
      },
      (error: unknown) => {
        updatePassword(
          error instanceof Error
            ? error
            : new Error("Unable to request the PDF password."),
        );
      },
    );
  };
}
